import { getCookie } from "@/utils/cookie";

export default function getLangCookie() {
  return getCookie("LANG_ID");
}
